module.exports = __webpack_public_path__ + "img/computer6.4ef04fa5.gif";